import React, {FC, useEffect, useRef} from "react";
import {ShelfProps} from "./Shelf.types";
import styles from "./Shelf.module.scss";

const Shelf: FC<ShelfProps> = ({children, open, onAnimationEnd, onClose}) => {
    const ref = useRef(null);

    const onAnimationEndListener = () => {
        if (!open) {
            if (onAnimationEnd) {
                onAnimationEnd();
            }
        }
    }

    useEffect(() => {
        ref.current?.addEventListener("animationend", onAnimationEndListener);
        return () => {
            ref.current?.removeEventListener("animationend", onAnimationEndListener);
        }
    }, []);

    const onBackdropClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (e.target === e.currentTarget) {
            onClose?.();
        }
    }

    return (
        <div className={[styles.Shelf, !open && styles.hidden].join(" ")}
             data-testid="Shelf"
             ref={ref}
             onClick={onBackdropClick}
        >{children}</div>
    );
};

export default Shelf;
